import styles from './SectionHeader.module.css';

export default function SectionHeader({
  title,
  subtitle,
  align = 'left',   // 'left' | 'center'
  tag,              // optional badge above title
  className = '',
}) {
  return (
    <div
      className={`${styles.wrap} ${align === 'center' ? styles.center : ''} ${className}`}
    >
      {tag && (
        <span className={styles.tag}>
          <span className={styles.tagDot} aria-hidden="true" />
          {tag}
        </span>
      )}
      <h2 className={styles.title}>{title}</h2>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
}